module.exports = __webpack_public_path__ + "static/media/ec.5856e48d.svg";